import Shared from './Templates/Core/JS/Shared.js';

const ServiceWorkerHelper = (function () {
	'use strict';

	const Logic = {
		button: null,

		/**
		 * Initialized the main functionality.
		 *
		 * @return void
		 */

		init() {
			// Check for Service Worker browser support.
			if (!('serviceWorker' in navigator)) {
				console.warn(
					'ServiceWorker.Logic(): Service Workers are not supported in this browser.',
					navigator.appCodeName
				);
				return;
			}

			this.button = document.querySelector('#AddToHomeScreen');
			if (!this.button) {
				console.error('ServiceWorker.installScript(): #AddToHomeScreen not found.');
				return;
			}

			// Install the 'Offline' Service Worker and hide the button.
			this.button.style.display = 'none';
			this.installScript();
		},

		/**
		 * Installs the Service Worker and performs most critical checks.
		 *
		 * @return void
		 */

		installScript() {
			navigator.serviceWorker
				.register(`${Shared.getBaseUrl()}Offline.js`, { scope: '/' })
				.then(() => {
					// Initialize the event listener for the "beforeinstallprompt" event.
					window.addEventListener('beforeinstallprompt', (event) => {
						this.promptInstallBanner(event);
					});

					/*
				 User is offline (temporarily) and see if one out of two tracking
				 options are available so we can at least send some tracking.
				  */
					if (navigator.onLine === false && window.snowplow) {
						// Send an event to Redshift to indicate that the user was offline.
						window.snowplow('trackStructEvent', {
							category: 'Online Status',
							action: navigator.onLine.toString(),
							value: 10
						});
					}
				})
				.catch(function (error) {
					// Registration failed.
					console.error('ServiceWorker.installScript(): Service Worker registration failed', error);
				});
		},

		/**
		 * Prompts the install banner on demand via a click event listener.
		 *
		 * @param event {Object}
		 * @constructor
		 *
		 * @return void
		 */

		promptInstallBanner(event) {
			// Prevent Chrome <67 from automatically showing the prompt.
			event.preventDefault();

			// Update the UI and notify the user they can add to home screen.
			this.button.style.display = 'block';

			this.button.addEventListener('click', () => {
				// Show the prompt.
				event.prompt();

				// Hide our user interface that shows our A2HS button.
				this.button.style.display = 'none';

				// Wait for the user to respond to the prompt
				event.userChoice.then((choiceResult) => {
					// check the current page
					const currentPage = window.location.href;

					// See if one out of two is available so we can at least send some tracking.
					if (window.snowplow) {
						// Send an event to Redshift to track "Add to home screen" events.
						window.snowplow('trackStructEvent', {
							category: 'PWA Install Prompt',
							action: choiceResult.outcome,
							label: currentPage,
							value: 10
						});
					}

					event = null;
				});
			});
		}
	};

	// Make methods publicly available.
	return {
		init() {
			Logic.init();
		}
	};
})();

document.addEventListener('DOMContentLoaded', () => {
	ServiceWorkerHelper.init();
});
